export default __webpack_public_path__ + "static/media/hero_desktop.baa94088.png";